<template>
  <v-menu
    v-model="menu2"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-list class="py-0 cross-row">
        <v-divider></v-divider>
        <v-list-item v-ripple v-on="on">
          <v-list-item-content>
            <v-list-item-title class="body-2">{{ date }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-calendar-month</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
    </template>
    <v-date-picker
      v-model="date"
      @input="menu2 = false"
      locale="zh-tw"
      :day-format="dayFormat"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ["label"],
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false
  }),
  computed: {
    // computedDateFormatted() {
    //   return this.formatDate(this.date);
    // }
  },
  methods: {
    // formatDate(date) {
    //   if (!date) return null;
    //   const [year, month, day] = date.split("-");
    //   return `${year}-${month}-${day}`;
    // },
    dayFormat(day) {
      return day.split("-")[2].replace(/^0/g, "");
    },
    getTime() {
      if (!this.date) return null;
      const [year, month, day] = this.date.split("-");
      console.log("date:" + this.date);
      return new Date(year, month - 1, day, 0, 0, 0, 0).getTime();
    },
    getDate() {
      if (!this.date) return null;
      return this.date;
    },
    reset() {
      this.date = new Date().toISOString().substr(0, 10);
    },
    setDate(newDate) {
      this.date = newDate;
    }
  }
};
</script>
